import css from "styled-jsx/css";

export const componentStyles = css`
  .product-card-title {
    display: flex;
    gap: 16px;

    :global(.main-title) {
      font-size: 1.25rem;
      font-weight: 600;
      line-height: normal;
    }

    :global(.picture-component) {
      :global(img) {
        width: 50px;
        object-fit: contain;
      }
    }
  }
`;
